var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C3.346 8 2 6.654 2 5C2 3.346 3.346 2 5 2C6.654 2 8 3.346 8 5C8 6.654 6.654 8 5 8ZM5 4C4.449 4 4 4.448 4 5C4 5.552 4.449 6 5 6C5.551 6 6 5.552 6 5C6 4.448 5.551 4 5 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C3.346 15 2 13.654 2 12C2 10.346 3.346 9 5 9C6.654 9 8 10.346 8 12C8 13.654 6.654 15 5 15ZM5 11C4.449 11 4 11.448 4 12C4 12.552 4.449 13 5 13C5.551 13 6 12.552 6 12C6 11.448 5.551 11 5 11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22C3.346 22 2 20.654 2 19C2 17.346 3.346 16 5 16C6.654 16 8 17.346 8 19C8 20.654 6.654 22 5 22ZM5 18C4.449 18 4 18.448 4 19C4 19.552 4.449 20 5 20C5.551 20 6 19.552 6 19C6 18.448 5.551 18 5 18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H11C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H11C10.4477 4 10 4.44772 10 5C10 5.55228 10.4477 6 11 6H20C20.5523 6 21 5.55228 21 5C21 4.44772 20.5523 4 20 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJob);
export default __webpack_public_path__ + "static/media/icon-job.9b31216f5fd183ecac3928f35e796134.svg";
export { ForwardRef as ReactComponent };